module.exports = __webpack_public_path__ + "static/media/GooglePlay.5c8c1fe6.png";